export type ErrorSeverity = 'fatal' | 'recoverable';

const FATAL_PATTERNS = [
  /no sessionId/i,
  /no session id/i,
  /chunk load error/i,
  /failed to fetch/i,
  /loading chunk \d+ failed/i,
];

export const classifyError = (error: unknown): ErrorSeverity => {
  const message = error instanceof Error ? error.message : String(error);

  return FATAL_PATTERNS.some((p) => p.test(message)) ? 'fatal' : 'recoverable';
};
